import * as React from "react";
import { useTranslation } from "react-i18next";
import { Field } from "formik";
import styled from "styled-components";
import { Select } from "components/common";
import SelectGroup from "components/common/SelectGroup";
import CapabilitySelect from "../CapabilitySelect";
import { StyledGranteeIcon } from "../CommonStyledComponents";
const GranteesSelect = styled(Select)`
  flex: 1;
`;
const GranteesSelectOption = styled.div`
  display: flex;
  align-items: center;
`;
const StyledSelectGroup = styled(SelectGroup)`
  flex: 1;

  > div:last-child {
    flex: 0.5;
  }
`;
const _granteesOptions = (grantees) => grantees.map((grantee) => ({ label: grantee.title, value: grantee.id, granteeType: grantee.type })).toJS();
const _isRequired = (field) => (value) => !value ? `The ${field} is required` : void 0;
const _renderGranteesSelectOption = ({ label, granteeType }) => /* @__PURE__ */ React.createElement(GranteesSelectOption, null, /* @__PURE__ */ React.createElement(StyledGranteeIcon, { type: granteeType }), label);
const GranteesSelectorFormGroup = ({ availableGrantees, availableCapabilities }) => {
  const { t } = useTranslation("users");
  const granteesOptions = _granteesOptions(availableGrantees);
  return /* @__PURE__ */ React.createElement(StyledSelectGroup, null, /* @__PURE__ */ React.createElement(Field, { name: "granteeId", validate: _isRequired("grantee") }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(
    GranteesSelect,
    {
      onChange: (granteeId) => onChange({ target: { value: granteeId, name } }),
      optionRenderer: _renderGranteesSelectOption,
      options: granteesOptions,
      placeholder: t("permissions.share.search_placeholder"),
      value
    }
  )), /* @__PURE__ */ React.createElement(CapabilitySelect, { capabilities: availableCapabilities }));
};
export default GranteesSelectorFormGroup;
